import { Exclude, Expose, Transform, instanceToPlain, plainToInstance } from 'class-transformer';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { RecurrenceOptions } from '../../constants-repository/recurrence.constants';
import { FileNameModel } from '../file/file-name.model';
import { FileModel } from '../file/file.model';
import { TagModel } from '../tag/tag.model';

export class GlobalExpenseModel {
  public id? = null;

  public name = '';

  @Expose({ name: 'invoice_date' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public invoiceDate = new Date();

  @Expose({ name: 'value' })
  public amount = 0;

  @Expose({ name: 'tag_ids' })
  @Exclude({ toClassOnly: true })
  public tagIds: number[] = [];

  @Expose({ name: 'tags' })
  @Exclude({ toPlainOnly: true })
  public tags: TagModel[] = [];

  public supplier = '';

  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public due = new Date();

  public recurrence: RecurrenceOptions | null = null;

  @Expose({ name: 'recurrence_end' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public recurrenceEnd = new Date();

  @Expose({ name: 'is_paid' })
  public isPaid = false;

  @Expose({ name: 'attachments' })
  @Transform(({ value, type }) => {
    if (!value) {
      return null;
    }

    // From server (plain to class) - expect FileNameModel structure
    if (type === 0) {
      return plainToInstance(FileNameModel, value);
    }

    // To server (class to plain) - could be FileModel
    if (type === 1) {
      return instanceToPlain(value);
    }

    return value;
  })
  public attachment: FileNameModel | FileModel = null;
}

export class ProjectExpenseModel extends GlobalExpenseModel {
  @Expose({ name: 'deduct_from_budget' })
  public deductFromBudget = false;

  @Expose({ name: 'is_billable' })
  public isBillable = false;

  @Expose({ name: 'project' })
  public projectId = -1;
}

export class OperatingCostsModel extends GlobalExpenseModel {}
